<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Author-tp">Paul James</p>
<p class="Title-tp">SHADOWS &amp; ANGELS</p>
<div class="_idGenObjectLayout-1">
<div class="Imprint" id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-2" src="image/Logo-for-titlepages-new-bw.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781788480116_EPUB1.vue?1a801ae2